import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AuthModal from './AuthModal';
import UserMenu from './UserMenu';

const AuthButton = () => {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authModalView, setAuthModalView] = useState('login');
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center gap-2">
        <div className="w-20 h-9 bg-muted animate-pulse rounded-lg" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <UserMenu />;
  }

  return (
    <>
      <div className="flex items-center gap-2">
        <button
          onClick={() => {
            setAuthModalView('login');
            setShowAuthModal(true);
          }}
          className="px-4 py-2 text-sm font-medium text-foreground hover:text-primary transition-colors"
        >
          Login
        </button>
        <button
          onClick={() => {
            setAuthModalView('register');
            setShowAuthModal(true);
          }}
          className="px-4 py-2 text-sm font-medium bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
        >
          Register
        </button>
      </div>
      
      <AuthModal 
        isOpen={showAuthModal} 
        onClose={() => setShowAuthModal(false)}
        defaultView={authModalView}
      />
    </>
  );
};

export default AuthButton;
